import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { JobfairService } from '../service/jobfair.service';

@Component({
	selector: 'app-info',
	templateUrl: './info.page.html',
	styleUrls: ['./info.page.scss'],
})
export class InfoPage implements OnInit {
	routerURL$ = this.router.events.pipe(
		filter(val => val instanceof NavigationEnd),
		tap((val: any) => {
			if (val.url.indexOf('/schedule-event') > -1) {
				this.class = 'schedule-event';
			} else if (val.url.indexOf('/schedule') > -1) {
				this.class = 'schedule';
			} else if (val.url.indexOf('/jobfair-announce') > -1) {
				this.class = 'jobfair-announce';
			} else if (val.url.indexOf('/jobfair-faq') > -1) {
				this.class = 'jobfair-faq';
			} else if (val.url.indexOf('/notification-data') > -1) {
				this.class = 'notification-data';
			} else if (val.url.indexOf('/participants') > -1) {
				this.class = 'participants';
			} else if (val.url.indexOf('/participatingcompanies') > -1) {
				this.class = 'participatingcompanies';
			}
		}),
	);

	class = 'schedule';
	jobFairId: any = '';
	jobFairName = { title: '' };
	constructor(
		public router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private jobfairService: JobfairService,
	) {
		const locationPath: Array<string | any> = this.location.path().split('/');

		this.class = locationPath[5];
		this.jobFairId = locationPath[4];

		this.jobfairService.loadJobFairListData().subscribe();

		this.jobfairService.fetchJobFairListData().subscribe((data: any) => {
			if (data.data.data) {
				this.jobFairName = data.data.data.find(
					(data: any) => data.id == this.jobFairId,
				);
			}
		});
	}

	ngOnInit() {}
	viewupdate(str: any) {
		this.activatedRoute.params.subscribe((data: any) => {
			this.router.navigate([`/app/jobfair/info/${data.id}/${str}`]);
		});
	}
}
